import React, { memo } from "react";

export const ListReportantes = memo(({ reportantes }: any) => {
    return reportantes?.map((value: any) => (
        value.$$href && value.$$title &&
        <option key={value.$$instanceId} value={value.$$title}>{value.$$title}</option>
    ))
});